<form [formGroup]="form" (ngSubmit)="formService.submit()">

    <div class="page_title">
        <div class="row marges">

            <div class="col y_items_center">
                <h1 class="title">{{ 'giftVoucher.read.value' | translate }}</h1>
            </div>

            <div class="col_content y_items_center">

                <!-- Retour -->

                <button class="btn_cta btn_lines btn_little" type="button" (click)="redirectToList()">
                    {{ 'giftVoucher.list.back.value' | translate }}
                </button>

                <!-- Soumission -->

                <button class="btn_cta btn_little" type="submit" [disabled]="!isOfferOwner || giftVoucher.status === 'forwarded'">
                    {{ 'form.submit.action.value'|translate }}
                </button>

            </div>
        </div>
    </div>

    <!-- Gestion des onglets -->

    <mat-tab-group>
        <mat-tab [label]="'giftVoucher.read.data.folder.value' | translate">
            <ng-container *ngTemplateOutlet="folderData"></ng-container>
        </mat-tab>
        <mat-tab [label]="'giftVoucher.read.data.value' | translate">
            <ng-container *ngTemplateOutlet="giftVoucherData"></ng-container>
        </mat-tab>
        <mat-tab [label]="'booking.read.data.pricing.value' | translate">
            <ng-container *ngTemplateOutlet="pricingData"></ng-container>
        </mat-tab>
        <ng-container *ngIf="userService.hasOneOfThisRoles(user, ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])">
            <mat-tab [label]="'giftVoucher.read.data.download.value' | translate">
                <ng-container *ngTemplateOutlet="downloadData"></ng-container>
            </mat-tab>
        </ng-container>
        <mat-tab [label]="'giftVoucher.read.data.distributor.contactDetails.value' | translate">
            <ng-container *ngTemplateOutlet="distributorContactDetails"></ng-container>
        </mat-tab>
        <mat-tab [label]="'giftVoucher.read.data.creator.contactDetails.value' | translate">
            <ng-container *ngTemplateOutlet="creatorContactDetails"></ng-container>
        </mat-tab>
        <mat-tab *ngIf="!isAdmin()" [label]="'giftVoucher.read.data.buyer.contactDetails.value' | translate">
            <ng-container *ngTemplateOutlet="buyerContactDetails"></ng-container>
        </mat-tab>
        <mat-tab *ngIf="!isAdmin()" [label]="'giftVoucher.read.data.beneficiary.contactDetails.value' | translate">
            <ng-container *ngTemplateOutlet="beneficiaryContactDetails"></ng-container>
        </mat-tab>
    </mat-tab-group>

</form>

<!-- Suivi du dossier -->

<ng-template #folderData [formGroup]="form">

    <ng-container [formGroup]="form">

        <div class="row marges ligne_form ">

            <div class="col_6">

                <div class="form-group">

                    <!-- Statut bon cadeau-->

                    <div class="ligne_form row_marges">

                        <div class="col_12">

                            <div class="form-group">

                                <select class="form-control" formControlName="status" id="status" required>

                                    <option *ngFor="let item of status" [value]="item.id">{{ item.label | translate }}</option>

                                </select>

                                <label class="required" for="status">{{ 'giftVoucher.list.fields.status.value' | translate }}</label>

                                <mat-error *ngIf="form.get('status').invalid && (form.get('status').dirty || form.get('status').touched)">

                                    <div class="invalid-feedback">

                                        <div *ngIf="form.get('status').errors.required">{{ 'form.control.error.required.value' | translate }}</div>

                                    </div>

                                </mat-error>
                            </div>

                        </div>

                    </div>

                    <div class="row marges ligne_form" *ngIf="isForwarded">

                       <div class="col_12">

                           <div class="form-group">

                               <!-- Nom du nouveau client -->

                               <p *ngIf="!isAdmin()" class="read">
                                   <strong>{{ 'giftVoucher.read.fields.forwarded.beneficiary.lastName.value' | translate }} : </strong>
                                   {{ giftVoucher.transferredGiftVoucher.beneficiary.lastName }}
                               </p>

                               <!-- Prénom du nouveau client -->

                               <p *ngIf="!isAdmin()" class="read">
                                   <strong>{{ 'giftVoucher.read.fields.forwarded.beneficiary.firstName.value' | translate }} : </strong>
                                   {{ giftVoucher.transferredGiftVoucher.beneficiary.firstName }}
                               </p>

                               <!-- Email du nouveau client -->

                               <p *ngIf="!isAdmin()" class="read">
                                   <strong>{{ 'giftVoucher.read.fields.forwarded.beneficiary.email.value' | translate }} : </strong>
                                   {{ giftVoucher.transferredGiftVoucher.beneficiary.email }}
                               </p>

                               <!-- Numéro de bon cadeau -->

                               <p class="read">
                                   <strong>{{ 'giftVoucher.read.fields.forwarded.code.value' | translate }} : </strong>
                                   {{ giftVoucher.transferredGiftVoucher.code }}
                               </p>

                           </div>

                       </div>

                    </div>

                    <!-- Commentaire -->

                    <div class="row marges ligne_form">

                        <div class="col_12">

                            <div class="form-group">

                                <textarea class="form-control" formControlName="comment" id="comment"></textarea>

                                <label for="comment">{{'giftVoucher.read.fields.comment.value' | translate}}</label>

                            </div>

                        </div>

                    </div>

                    <!-- Société en charge de la relation client -->

                    <div class="ligne_form row marges">

                        <div class="col_12">

                            <div class="form-group">

                                <p class="read">
                                    <strong>{{ 'booking.read.fields.society.inChargeOfCustomerRelation.value' | translate }} : </strong>
                                    {{ giftVoucher.offerOwnerSocietyData.societyName }}
                                </p>

                            </div>

                        </div>

                    </div>

                    <!-- Collaborateur -->

                    <div class="ligne_form row_marges">

                        <div class="col_12">

                            <div class="form-group">

                                <p class="read ligne_form">
                                    <strong class="subtitle_green">{{ 'booking.list.fields.responsibleUser.value' | translate }}</strong>
                                </p>

                                <div style="margin-top: 12px">
                                    <app-core-select-search [configuration]="collaboratorSearchConfiguration" [sourceCallback]="collaboratorSearchSourceCallback" [formGroupReference]="form" [formControlNameReference]="'responsibleUser'"></app-core-select-search>
                                </div>

                                <ng-container *ngIf="currentCollaborator && (currentCollaborator.society.id === giftVoucher.offerOwnerSociety?.id) && hasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR']) && !isUpdateCollaboratorAllowed">

                                    <mat-error style="padding: 0">

                                        <div class="invalid-feedback">
                                            <div>{{ 'collaborator.update.denied.description.value' | translate }}</div>
                                        </div>

                                    </mat-error>

                                </ng-container>

                                <mat-error *ngIf="form.get('responsibleUser').invalid && (form.get('responsibleUser').dirty || form.get('responsibleUser').touched)">

                                    <div class="invalid-feedback">

                                        <div *ngIf="form.get('responsibleUser').errors.required">{{ 'form.control.error.required.value' | translate }}</div>

                                    </div>

                                </mat-error>

                            </div>
                        </div>
                    </div>

                    <ng-container *ngIf="!!currentCollaborator">

                        <!-- Données du collaborateur -->

                        <div class="ligne_form row marges">

                            <div class="col_12">

                                <div class="form-group">
                                    <p class="read">
                                        <strong class="subtitle_green">{{ 'collaborator.data.plural.value' | translate }}</strong>
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="ligne_form row marges">

                            <div class="col_12">

                                <div class="form-group">

                                    <!-- ID -->

                                    <ng-container *ngIf="currentCollaborator?.id">

                                        <p class="read">
                                            <strong>{{ 'collaborator.id.value' | translate }} : </strong>
                                            {{ currentCollaborator?.id }}
                                        </p>

                                    </ng-container>

                                    <!-- Nom -->

                                    <ng-container *ngIf="currentCollaborator?.firstName || currentCollaborator?.lastName">

                                        <p class="read">
                                            <strong>{{ 'collaborator.name.value' | translate }} : </strong>
                                            {{ currentCollaborator?.firstName }} {{ currentCollaborator?.lastName }}
                                        </p>

                                    </ng-container>

                                    <!-- Service -->

                                    <ng-container *ngIf="currentCollaborator?.service">

                                        <p class="read">
                                            <strong>{{ 'collaborator.service.value' | translate }} : </strong>
                                            {{ currentCollaborator?.service }}
                                        </p>

                                    </ng-container>

                                    <!-- Email -->

                                    <ng-container *ngIf="currentCollaborator?.email">

                                        <p class="read">
                                            <strong>{{ 'collaborator.email.value' | translate }} : </strong>
                                            {{ currentCollaborator?.email }}
                                        </p>

                                    </ng-container>

                                    <!-- Téléphone -->

                                    <ng-container *ngIf="currentCollaborator?.switchboardPhone">

                                        <p class="read">
                                            <strong>{{ 'collaborator.phone.value' | translate }} : </strong>
                                            {{ currentCollaborator?.switchboardPhone }}
                                        </p>

                                    </ng-container>

                                    <!-- Adresse -->

                                    <ng-container *ngIf="currentCollaborator?.address">

                                        <p class="read">
                                            <strong>{{ 'collaborator.address.value' | translate }} : </strong>
                                            {{ currentCollaborator?.address.address }}, {{ currentCollaborator?.address.zipcode }} {{ currentCollaborator?.address.city }}
                                        </p>

                                    </ng-container>

                                </div>

                            </div>

                        </div>

                    </ng-container>

                    <ng-container *ngIf="!!giftVoucher.owner">

                        <!-- Collaborateur à l'origine de la demande -->

                        <div class="ligne_form row marges">

                            <div class="col_12">

                                <div class="form-group">
                                    <p class="read">
                                        <strong class="subtitle_green">{{ 'booking.read.fields.owner.value' | translate }}</strong> : {{ giftVoucher.owner.firstName }} {{ giftVoucher.owner.lastName }} <ng-container *ngIf="giftVoucher.owner.service">({{ giftVoucher.owner.service }})</ng-container>
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="ligne_form row marges">

                            <div class="col_12">

                                <div class="form-group">

                                    <!-- ID -->

                                    <ng-container *ngIf="giftVoucher.owner?.id">

                                        <p class="read">
                                            <strong>{{ 'collaborator.id.value' | translate }} : </strong>
                                            {{ giftVoucher.owner?.id }}
                                        </p>

                                    </ng-container>

                                    <!-- Société -->

                                    <ng-container *ngIf="giftVoucher.owner?.society">

                                        <p class="read">
                                            <strong>{{ 'collaborator.list.fields.societyName.value' | translate }} : </strong>
                                            {{ giftVoucher.owner?.society.name }}
                                        </p>

                                    </ng-container>

                                    <!-- Nom -->

                                    <ng-container *ngIf="giftVoucher.owner?.firstName || giftVoucher.owner?.lastName">

                                        <p class="read">
                                            <strong>{{ 'collaborator.name.value' | translate }} : </strong>
                                            {{ giftVoucher.owner?.firstName }} {{ giftVoucher.owner?.lastName }}
                                        </p>

                                    </ng-container>

                                    <!-- Service -->

                                    <ng-container *ngIf="giftVoucher.owner?.service">

                                        <p class="read">
                                            <strong>{{ 'collaborator.service.value' | translate }} : </strong>
                                            {{ giftVoucher.owner?.service }}
                                        </p>

                                    </ng-container>

                                    <!-- Email -->

                                    <ng-container *ngIf="giftVoucher.owner?.email">

                                        <p class="read">
                                            <strong>{{ 'collaborator.email.value' | translate }} : </strong>
                                            {{ giftVoucher.owner?.email }}
                                        </p>

                                    </ng-container>

                                    <!-- Téléphone -->

                                    <ng-container *ngIf="giftVoucher.owner?.switchboardPhone">

                                        <p class="read">
                                            <strong>{{ 'collaborator.phone.value' | translate }} : </strong>
                                            {{ giftVoucher.owner?.switchboardPhone }}
                                        </p>

                                    </ng-container>

                                    <!-- Adresse -->

                                    <ng-container *ngIf="currentCollaborator?.address">

                                        <p class="read">
                                            <strong>{{ 'collaborator.address.value' | translate }} : </strong>
                                            {{ giftVoucher.owner?.address.address }}, {{ giftVoucher.owner?.address.zipcode }} {{ giftVoucher.owner?.address.city }}
                                        </p>

                                    </ng-container>

                                </div>

                            </div>

                        </div>

                    </ng-container>

                </div>

            </div>

        </div>

    </ng-container>

</ng-template>

<!-- Informations associées à la réservation -->

<ng-template #giftVoucherData>

    <div class="ligne_form row marges">

        <div class="col_12">

            <div class="form-group">

                <!-- Référence -->

                <p class="read">
                    <strong>{{ 'giftVoucher.read.fields.reference.value' | translate }} : </strong>
                    {{ giftVoucher.reference }}
                </p>

                <!-- Numéro du bon cadeaau -->

                <p class="read">
                    <strong>{{ 'giftVoucher.read.fields.code.value' | translate }} : </strong>
                    {{ giftVoucher.code }}
                </p>

                <!-- Date de commande -->

                <p class="read">
                    <strong>{{ 'giftVoucher.read.fields.createdAt.value' | translate }} : </strong>
                    {{ (giftVoucher.createdAt | date : 'fullDate' : null: localeId) | titlecase }}
                </p>

                <!-- Durée de validité -->

                <p class="read">
                    <strong>{{ 'giftVoucher.read.fields.expiryDate.value' | translate }} : </strong>
                    {{ (giftVoucher.expiryDate | date : 'fullDate' : null: localeId) | titlecase }}
                </p>

                <!-- Type de bon cadeau -->

                <p class="read">
                    <strong>{{ 'giftVoucher.read.fields.type.value' | translate }} : </strong>
                    {{ 'giftVoucher.read.fields.type.' + giftVoucher.type + '.value' | translate }}
                </p>

                <ng-container *ngIf="(giftVoucher.type === 'physical') && (isAdmin() || (giftVoucher.offerOwnerSociety.id === society.id))">

                    <!-- Info pour l'envoi du bon cadeau physique -->

                    <p class="read message-help">
                        <mat-icon>info</mat-icon> <span>{{ ('giftVoucher.read.fields.type.physical.' + giftVoucher.recipient + '.help.value') | translate }}</span>
                    </p>

                </ng-container>

                <ng-container *ngIf="giftVoucher.transporter">

                    <!-- Nom du transporteur -->

                    <p class="read">
                        <strong>{{ 'giftVoucher.read.fields.transporter.name.value' | translate }} : </strong>
                        {{ giftVoucher.transporter.name }}
                    </p>

                </ng-container>

                <ng-container *ngIf="giftVoucher.nbAdult > 0">

                    <!-- Nombre d'adulte(s) -->

                    <p class="read">
                        <strong>{{ 'giftVoucher.read.fields.adult.count.value' | translate }} : </strong>
                        {{ giftVoucher.nbAdult }}
                    </p>

                </ng-container>

                <ng-container *ngIf="giftVoucher.nbChild > 0">

                    <!-- Nombre d'enfant(s) -->

                    <p class="read">
                        <strong>{{ 'giftVoucher.read.fields.child.count.value' | translate }} : </strong>
                        {{ giftVoucher.nbChild }}
                    </p>

                </ng-container>

                <!--  Bon de cadeau renouvelable  -->

                <p class="read">
                    <strong>{{ 'giftVoucher.read.fields.renewal.value' | translate }} : </strong>
                    {{ 'giftVoucher.list.fields.renewed.' + giftVoucher.isRenewable + '.value' | translate }}
                </p>

                <ng-container *ngIf="giftVoucher.isRenewable">

                    <p class="read">
                        <strong>{{ 'giftVoucher.read.fields.renewal.price.value' | translate }} : </strong>
                        {{ (renewalAmountTTC > 0) ? ((renewalAmountTTC | parsePrice) + ' ' + currencySymbol + ' ' + ('taxes.including.value' | translate) + ' (' + (renewalAmountHT | parsePrice) + ' ' + currencySymbol + ' ' + ('taxes.excluding.value' | translate) + ')') : ('giftVoucher.read.fields.renewal.free.value' | translate) }}
                    </p>

                    <p class="read">
                        <strong>{{ 'giftVoucher.read.fields.renewal.renewed.value' | translate }} : </strong>
                        {{ 'giftVoucher.list.fields.renewed.' + giftVoucher.isRenewed + '.value' | translate  }}
                    </p>

                </ng-container>

                <!-- Nom de l'offre -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.offerName.value' | translate }} : </strong>
                    <a *ngIf="!giftVoucher.isDetached" [routerLink]="['/account/offer/read', offer.id]" [queryParams]="{ origin: 'giftVoucherRead', giftVoucher: giftVoucher.id }">{{ translationService.getFallbackTranslation(offer.translations).name}}</a>
                    <span *ngIf="giftVoucher.isDetached">{{ translationService.getFallbackTranslation(offer.translations).name}}</span>
                </p>

                <!-- Commentaire -->

                <ng-container *ngIf="!isAdmin() && giftVoucher.buyer.comment?.length">

                    <p class="read">
                        <strong>{{ 'booking.read.fields.customerComment.value' | translate }} : </strong>
                        {{ giftVoucher.buyer.comment }}
                    </p>

                </ng-container>

            </div>
        </div>
    </div>

    <div class="ligne_form row marges">

        <div class="col_6">

            <div class="form-group">
                <p class="read">
                    <strong class="subtitle_green">{{ 'booking.read.title.description' | translate }}</strong>
                </p>

            </div>
        </div>
    </div>


    <div class="ligne_form row marges">

        <div class="col_6">

            <div class="form-group">
                <div class="read">

                    <mat-accordion multi>

                        <!-- Description -->

                        <mat-expansion-panel>

                            <mat-expansion-panel-header>

                                <mat-panel-title>{{ 'booking.read.fields.description.value' | translate }}</mat-panel-title>

                            </mat-expansion-panel-header>

                            <div class="txt_offer">

                                <p [innerHTML]="translationService.getFallbackTranslation(offer.translations).description|safeHtml"></p>

                            </div>

                        </mat-expansion-panel>

                        <!-- Compris dans l'offre -->

                        <mat-expansion-panel>

                            <mat-expansion-panel-header>

                                <mat-panel-title>{{ 'offer.form.fields.included.value' | translate }}</mat-panel-title>

                            </mat-expansion-panel-header>

                            <div *ngFor="let included of translatedIncludedsItemFields" class="txt_offer">

                                <p class="title_2">{{ included?.title }}</p>

                                <p>{{ included?.description }}</p>

                            </div>

                        </mat-expansion-panel>

                        <!-- Non Compris dans l'offre -->

                        <mat-expansion-panel>

                            <mat-expansion-panel-header>

                                <mat-panel-title>{{ 'offer.form.fields.included.no.value' | translate }}</mat-panel-title>

                            </mat-expansion-panel-header>

                            <div *ngFor="let included of translatedNotIncludedsItemFields" class="txt_offer little">

                                <p class="title_2">{{ included?.title }}</p>

                                <p>{{ included?.description }}</p>

                            </div>

                        </mat-expansion-panel>

                        <ng-container *ngIf="translationService.getFallbackTranslation(offer.translations).accommodation?.length">

                            <!-- Hébergement -->

                            <mat-expansion-panel>

                                <mat-expansion-panel-header>

                                    <mat-panel-title>{{ 'booking.read.fields.accommodation.value' | translate }}</mat-panel-title>

                                </mat-expansion-panel-header>

                                <div class="txt_offer">

                                    <p [innerHTML]="translationService.getFallbackTranslation(offer.translations).accommodation|safeHtml"></p>

                                </div>

                            </mat-expansion-panel>

                        </ng-container>

                    </mat-accordion>

                </div>

            </div>

        </div>

    </div>

</ng-template>

<ng-template #pricingData>

    <!-- Promotion appliquée -->

    <ng-container *ngIf="giftVoucher.promotionData">

        <div class="ligne_form row marges col_12">
            <div class="col_12">
                <div class="form-group">
                    <p class="read">
                        <strong class="subtitle_green">{{ 'promotion.value' | translate }}</strong>
                    </p>
                </div>
            </div>
        </div>

        <div class="ligne_form row marges col_12">

            <div class="col_12">

                <div class="form-group">

                    <p class="read" *ngIf="giftVoucher.promotionData.code">
                        <strong>{{ 'booking.read.fields.promotion.code.value' | translate }} : </strong>
                        <span>{{ giftVoucher.promotionData.code }}</span>
                    </p>

                    <p class="read">
                        <strong>{{ 'booking.read.fields.promotion.percent.value' | translate }} : </strong>
                        <span>{{ giftVoucher.promotionData.value * 100 }} %</span>
                    </p>

                    <!-- Prix promotionnel -->

                    <p class="read">
                        <strong>{{ 'giftVoucher.read.fields.promotion.price.value' | translate }} : </strong>
                        {{ ((giftVoucher.promotionPrice / 100)|parsePrice) + ' ' + currencySymbol }}
                    </p>

                </div>
            </div>
        </div>

    </ng-container>

    <!-- Montants total du dossier -->

    <div class="ligne_form row marges col_12">
        <div class="col_12">
            <div class="form-group">
                <p class="read">
                    <strong class="subtitle_green">{{ 'booking.read.fields.amount.plural.total.value' | translate }}</strong>
                </p>
            </div>
        </div>
    </div>

    <div class="ligne_form row marges col_12">

        <div class="col_12">

            <div class="form-group">

                <!-- Prix -->

                <ng-container *ngIf="userService.isCurrentUserAdmin || isInCommercialRelationshipCharge">

                    <p class="read">
                        <strong>{{ 'giftVoucher.read.fields.price.value' | translate }} : </strong>
                        {{ ((giftVoucher.price / 100)|parsePrice) + ' ' + currencySymbol }}
                    </p>

                </ng-container>

                <!-- Prix du transporteur -->

                <ng-container *ngIf="giftVoucher.transporterPriceTTC">

                    <p class="read">
                        <strong>{{ 'giftVoucher.read.fields.transporter.price.value' | translate }} : </strong>
                        {{ 'giftVoucher.read.fields.transporter.price.ttc.value' | translate:{ price: ((giftVoucher.transporterPriceTTC / 100)|parsePrice), currency: currencySymbol } }}
                        ({{ 'giftVoucher.read.fields.transporter.price.ht.value' | translate:{ price: ((giftVoucher.transporterPriceHT / 100)|parsePrice), currency: currencySymbol } }})
                    </p>

                </ng-container>

                <!-- Montant public TTC du dossier (assurances incluses) -->

                <p class="read" *ngIf="giftVoucher.totalPrice && isInCommercialRelationshipCharge">
                    <strong>{{ 'booking.read.fields.price.ttc.with_permanent_option.value' | translate }} : </strong>
                    {{ ((giftVoucher.totalPrice / 100)|parsePrice) + ' ' + currencySymbol }}
                </p>

                <!-- Montant net TTC du dossier (hors assurance) -->

                <p class="read" *ngIf="giftVoucher.totalNetPrice">
                    <strong>{{ 'booking.read.fields.price.net.ttc.value' | translate }} : </strong>
                    {{ ((giftVoucher.totalNetPrice / 100)|parsePrice) + ' ' + currencySymbol }}
                </p>

            </div>
        </div>
    </div>

    <!-- Commission Ty-Win -->

    <ng-container *ngIf="(userService.isCurrentUserAdmin || userService.hasOneOfThisRoles(userService.currentUser.getValue(), ['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])) && (userService.isCurrentUserAdmin || (isOfferOwner || (!isOfferOwner && isInCommercialRelationshipCharge)))">

        <div class="ligne_form row marges col_12">
            <div class="col_12">
                <div class="form-group">
                    <p class="read">
                        <strong class="subtitle_green">{{ 'tywin.commission.value' | translate }}</strong>
                    </p>
                </div>
            </div>
        </div>

        <div class="ligne_form row marges col_12">

            <div class="col_12">

                <div class="form-group">

                    <!-- % (HT) de commission Ty-win -->

                    <ng-container *ngIf="userService.isCurrentUserAdmin || userService.hasOneOfThisRoles(userService.currentUser.getValue(), ['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])">

                        <ng-container *ngIf="userService.isCurrentUserAdmin; else internalCommissionAsSociety">

                            <p class="read">
                                <strong>{{ 'booking.read.fields.commission.internal.offerCreator.value' | translate }} : </strong>
                                <span>{{ giftVoucher.offerOwnerInternalCommission ? parsePercent(giftVoucher.offerOwnerInternalCommission * 100) : 'N/A' }}</span>
                            </p>

                            <p class="read">
                                <strong>{{ 'booking.read.fields.commission.internal.distributor.value' | translate }} : </strong>
                                <span>{{ giftVoucher.internalCommission ? parsePercent(giftVoucher.internalCommission * 100) : 'N/A' }}</span>
                            </p>

                        </ng-container>

                        <ng-template #internalCommissionAsSociety>

                            <ng-container *ngIf="isOfferOwner">

                                <p class="read">
                                    <strong>{{ 'booking.read.fields.commission.internal.value' | translate }} : </strong>
                                    <span>{{ giftVoucher.offerOwnerInternalCommission ? parsePercent(giftVoucher.offerOwnerInternalCommission * 100) : 'N/A' }}</span>
                                </p>

                            </ng-container>

                            <ng-container *ngIf="!isOfferOwner && isInCommercialRelationshipCharge">

                                <p class="read">
                                    <strong>{{ 'booking.read.fields.commission.internal.value' | translate }} : </strong>
                                    <span>{{ giftVoucher.internalCommission ? parsePercent(giftVoucher.internalCommission * 100) : 'N/A' }}</span>
                                </p>

                            </ng-container>

                        </ng-template>

                    </ng-container>

                    <!-- Montant (HT) de commission Ty-Win -->

                    <ng-container *ngIf="userService.isCurrentUserAdmin || userService.hasOneOfThisRoles(userService.currentUser.getValue(), ['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])">

                        <ng-container *ngIf="userService.isCurrentUserAdmin; else amountInternalCommissionAsSociety">

                            <p class="read">
                                <strong>{{ 'booking.read.fields.commission.internal.amount.offerCreator.value' | translate }} : </strong>
                                <span>{{ giftVoucher.amountOfferOwnerInternalCommission ? (((giftVoucher.amountOfferOwnerInternalCommission / 100)|parsePrice) + ' ' + currencySymbol) : 'N/A' }}</span>
                            </p>

                            <p class="read">
                                <strong>{{ 'booking.read.fields.commission.internal.amount.distributor.value' | translate }} : </strong>
                                <span>{{ giftVoucher.amountInternalCommission ? (((giftVoucher.amountInternalCommission / 100)|parsePrice) + ' ' + currencySymbol) : 'N/A' }}</span>
                            </p>

                        </ng-container>

                        <ng-template #amountInternalCommissionAsSociety>

                            <ng-container *ngIf="isOfferOwner">

                                <p class="read">
                                    <strong>{{ 'booking.read.fields.commission.internal.amount.value' | translate }} : </strong>
                                    <span>{{ giftVoucher.amountOfferOwnerInternalCommission ? (((giftVoucher.amountOfferOwnerInternalCommission / 100)|parsePrice) + ' ' + currencySymbol) : 'N/A' }}</span>
                                </p>

                            </ng-container>

                            <ng-container *ngIf="!isOfferOwner && isInCommercialRelationshipCharge">

                                <p class="read">
                                    <strong>{{ 'booking.read.fields.commission.internal.amount.value' | translate }} : </strong>
                                    <span>{{ giftVoucher.amountInternalCommission ? (((giftVoucher.amountInternalCommission / 100)|parsePrice) + ' ' + currencySymbol) : 'N/A' }}</span>
                                </p>

                            </ng-container>

                        </ng-template>

                    </ng-container>

                </div>
            </div>
        </div>

    </ng-container>

    <ng-container *ngIf="userService.isCurrentUserAdmin || (userService.hasOneOfThisRoles(userService.currentUser.getValue(), ['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR']) && (isInCommercialRelationshipCharge) || (isInCommercialRelationshipCharge && isOfferOwner))">

        <!-- Frais de transaction MangoPay -->

        <div class="ligne_form row marges col_12">
            <div class="col_12">
                <div class="form-group">
                    <p class="read">
                        <strong class="subtitle_green">{{ 'mangopay.fees.plural.amount.value' | translate }}</strong>
                    </p>
                </div>
            </div>
        </div>

        <div class="ligne_form row marges col_12">

            <div class="col_12">

                <div class="form-group">

                    <!-- % (HT) Frais de transaction MangoPay applicable sur Montant Public TTC du dossier -->

                    <ng-container *ngIf="userService.isCurrentUserAdmin || isInCommercialRelationshipCharge">

                        <p class="read">
                            <strong>{{ 'booking.read.fields.paymentFees.value' | translate }} : </strong>
                            <span>{{ giftVoucher.paymentFees ? parsePercent(giftVoucher.paymentFees * 100) : 'N/A' }}</span>
                        </p>

                    </ng-container>

                    <!-- Montant (HT) des frais de transaction MangoPay -->

                    <ng-container *ngIf="userService.isCurrentUserAdmin || (isInCommercialRelationshipCharge && isOfferOwner)">

                        <p class="read">
                            <strong>{{ 'booking.read.fields.paymentFees.amount.value' | translate }} : </strong>
                            <span>{{ giftVoucher.amountPaymentFees ? (((giftVoucher.amountPaymentFees / 100)|parsePrice) + ' ' + currencySymbol) : 'N/A' }}</span>
                        </p>

                    </ng-container>

                </div>
            </div>
        </div>

    </ng-container>

    <!-- Commission apporteurs d’affaires -->

    <ng-container *ngIf="giftVoucher.commission">

        <div class="ligne_form row marges col_12">
            <div class="col_12">
                <div class="form-group">
                    <p class="read">
                        <strong class="subtitle_green">{{ 'businessProvider.plural.commission.value' | translate }}</strong>
                    </p>
                </div>
            </div>
        </div>

        <div class="ligne_form row marges col_12">

            <div class="col_12">

                <div class="form-group">

                    <!-- % (HT) Commission distributeur applicable sur Montant net TTC du dossier -->

                    <ng-container *ngIf="userService.hasOneOfThisRoles(userService.currentUser.getValue(), ['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION'])">

                        <p class="read">
                            <strong>{{ 'booking.read.fields.commission.value' | translate }} : </strong>
                            <span>{{ giftVoucher.commission ? parsePercent(giftVoucher.commission * 100) : 'N/A' }}</span>
                        </p>

                    </ng-container>

                    <!-- Montant (HT) de la commission distributeur -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.commission.amount.value' | translate }} : </strong>
                        <span>{{ giftVoucher.amountCommission ? (((giftVoucher.amountCommission / 100)|parsePrice) + ' ' + currencySymbol) : 'N/A' }}</span>
                    </p>

                    <!-- Encaissement de la commission -->

                    <ng-container *ngIf="userService.isCurrentUserAdmin || userService.hasOneOfThisRoles(userService.currentUser.getValue(), ['ROLE_OFFER_CREATOR'])">

                        <ng-container *ngIf="giftVoucher.commissionPaymentStatus === 'paid'">

                            <p class="read">
                                <strong>{{ 'booking.read.fields.commission.receipt.value' | translate }} : </strong>
                                <span>{{ 'yes.value' | translate }}</span>
                            </p>

                        </ng-container>

                    </ng-container>

                </div>

            </div>

        </div>

    </ng-container>

    <div class="row ligne_form">
        <div class="col_12">
            <div class="form-group">
                <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon><span>{{ 'booking.data.pricing.description.value' | translate }}</span></span>
            </div>
        </div>
    </div>

</ng-template>

<!-- Téléchargement du bon cadeau -->

<ng-template #downloadData>

    <div>

        <ng-container *ngIf="giftVoucher.isAllowedDownloadFile">

            <div class="page_title">
                <div class="row marges">
                    <div class="col_content y_items_center">
                        <button class="btn_cta btn_little" type="button" (click)="$event.preventDefault(); downloadItem()">
                            {{ 'giftVoucher.read.fields.download.value'|translate }}
                        </button>
                    </div>
                </div>
            </div>

        </ng-container>

        <ng-container *ngIf="!giftVoucher.isAllowedDownloadFile">

            <div class="page_title">
                <div class="row marges">
                    <div class="col_content">
                        <p>{{ 'giftVoucher.download.unavailable.value' | translate: {creator: giftVoucher.offerOwnerSocietyData.societyName} }}</p>
                    </div>
                </div>
            </div>

        </ng-container>

    </div>

</ng-template>

<!-- Coordonnées du distributeur -->

<ng-template #distributorContactDetails>

    <ng-container [formGroup]="form">

        <div class="ligne_form row marges">

            <div class="col_12">

                <div class="form-group">

                    <!-- Nom du canal -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.channelName.value' | translate }} : </strong>
                        {{ giftVoucher.channel ? translationService.getFallbackTranslation(giftVoucher.channel.translations).name : ('booking.read.fields.channelName.none.value' | translate)}}
                    </p>

                    <!-- Site internet -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.channelMarketplace.value' | translate }} : </strong>
                        {{ (giftVoucher.channel && giftVoucher.channel.marketplace) ? giftVoucher.channel.marketplace.website : originUrl }}
                    </p>

                    <!-- Nom du propriétaire du canal -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.channel.owner.name.value' | translate }} : </strong>
                        {{ giftVoucher.channel ? giftVoucher.channel.society.name : giftVoucher.society.name }}
                    </p>

                    <!-- Email du propriétaire du canal -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.channel.owner.email.value' | translate }} : </strong>
                        {{ giftVoucher.channel ? giftVoucher.channel.society.email : giftVoucher.society.email }}
                    </p>

                    <!-- Téléphone du propriétaire du canal -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.channel.owner.phone.value' | translate }} : </strong>
                        {{ giftVoucher.channel ? giftVoucher.channel.society.phone : giftVoucher.society.phone }}
                    </p>

                </div>

            </div>

        </div>

    </ng-container>

</ng-template>

<!-- Coordonnées du créateur -->

<ng-template #creatorContactDetails>

    <div class="ligne_form row marges">

        <div class="col_12">

            <div class="form-group">

                <!-- Nom du créateur d'offre -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.offerProductor.value' | translate }} : </strong>
                    {{ giftVoucher.offerOwnerSocietyData.societyName }}
                </p>

                <!-- Email du créateur d'offre -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.offerProductor.email.value' | translate }} : </strong>
                    {{ giftVoucher.offerOwnerSocietyData.email }}
                </p>

                <!-- Téléphone du créateur d'offre -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.offerProductor.phone.value' | translate }} : </strong>
                    {{ giftVoucher.offerOwnerSocietyData.phone }}
                </p>

            </div>

        </div>

    </div>

</ng-template>

<!-- Coordonnées de l'acheteur -->

<ng-template #buyerContactDetails>

    <div class="ligne_form row marges">

        <div class="col_12">

            <div class="form-group">

                <!-- Société -->

                <ng-container *ngIf="giftVoucher.buyer.society">

                    <p class="read">
                        <strong>{{ 'booking.read.fields.customerSociety.value' | translate }} : </strong>
                        {{ giftVoucher.buyer.society }}<ng-container *ngIf="giftVoucher.buyer.customerType"> ({{ translationService.getFallbackTranslation(giftVoucher.buyer.customerType.translations).label }})</ng-container>
                    </p>

                </ng-container>

                <!-- Nom -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerName.value' | translate }} : </strong>
                    {{ giftVoucher.buyer.lastName }}
                </p>

                <!-- Prénom -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerFirstName.value' | translate }} : </strong>
                    {{ giftVoucher.buyer.firstName }}
                </p>

                <!-- Adresse -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerAddress.value' | translate }} : </strong>
                    {{ giftVoucher.buyer.address }}
                </p>

                <!-- Complément d'adresse -->

                <p class="read" *ngIf="giftVoucher.buyer.additionalAddress">
                    <strong>{{ 'booking.read.fields.customerAdditionalAddress.value' | translate }} : </strong>
                    {{ giftVoucher.buyer.additionalAddress }}
                </p>

                <!-- Code postal -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerZipcode.value' | translate }} : </strong>
                    {{ giftVoucher.buyer.zipcode }}
                </p>

                <!-- Ville -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerCity.value' | translate }} : </strong>
                    {{ giftVoucher.buyer.city }}
                </p>

                <!-- Région -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerRegion.value' | translate }} : </strong>
                    {{ giftVoucher.buyer.region }}
                </p>

                <!-- Pays -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerCountry.value' | translate }} : </strong>
                    {{ giftVoucher.buyer.country }}
                </p>

                <!-- Email -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerEmail.value' | translate }} : </strong>
                    {{ giftVoucher.buyer.email }}
                </p>

                <!-- Téléphone -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerFirstPhone.value' | translate }} : </strong>
                    {{ giftVoucher.buyer.phone }}
                </p>

            </div>

        </div>

    </div>

</ng-template>

<!-- Coordonnées du bénéficiaire -->

<ng-template #beneficiaryContactDetails>

    <div class="ligne_form row marges">

        <div class="col_12">

            <div class="form-group">

                <!-- Société -->

                <ng-container *ngIf="giftVoucher.beneficiary.society">

                    <p class="read">
                        <strong>{{ 'booking.read.fields.customerSociety.value' | translate }} : </strong>
                        {{ giftVoucher.beneficiary.society }}<ng-container *ngIf="giftVoucher.beneficiary.customerType"> ({{ translationService.getFallbackTranslation(giftVoucher.beneficiary.customerType.translations).label }})</ng-container>
                    </p>

                </ng-container>

                <!-- Nom -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerName.value' | translate }} : </strong>
                    {{ giftVoucher.beneficiary.lastName }}
                </p>

                <!-- Prénom -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerFirstName.value' | translate }} : </strong>
                    {{ giftVoucher.beneficiary.firstName }}
                </p>

                <!-- Adresse -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerAddress.value' | translate }} : </strong>
                    {{ giftVoucher.beneficiary.address }}
                </p>

                <!-- Complément d'adresse -->

                <p class="read" *ngIf="giftVoucher.beneficiary.additionalAddress">
                    <strong>{{ 'booking.read.fields.customerAdditionalAddress.value' | translate }} : </strong>
                    {{ giftVoucher.beneficiary.additionalAddress }}
                </p>

                <!-- Code postal -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerZipcode.value' | translate }} : </strong>
                    {{ giftVoucher.beneficiary.zipcode }}
                </p>

                <!-- Ville -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerCity.value' | translate }} : </strong>
                    {{ giftVoucher.beneficiary.city }}
                </p>

                <!-- Région -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerRegion.value' | translate }} : </strong>
                    {{ giftVoucher.beneficiary.region }}
                </p>

                <!-- Pays -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerCountry.value' | translate }} : </strong>
                    {{ giftVoucher.beneficiary.country }}
                </p>

                <!-- Email -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerEmail.value' | translate }} : </strong>
                    {{ giftVoucher.beneficiary.email }}
                </p>

                <!-- Téléphone -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.customerFirstPhone.value' | translate }} : </strong>
                    {{ giftVoucher.beneficiary.phone }}
                </p>

            </div>

        </div>

    </div>

</ng-template>

